import { UIElement, TransformOptions } from "./ui_element.js";

export class UICanvasRect extends UIElement
{
  private fill_color: string;
  private border_radius: number | number[];

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    fill_color: string,
    border_radius: number | number[] = 0,
    options?: TransformOptions
  )
  {
    super( ctx, x, y, width, height, false, false, options );
    this.fill_color = fill_color;
    this.border_radius = border_radius;
  }

  public setColor( color: string ): void
  {
    this.fill_color = color;
  }

  public setBorderRadius( radius: number | number[] ): void
  {
    this.border_radius = radius;
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();
    this.applyTransform();

    const x = -this.rect.getW2();
    const y = -this.rect.getH2();
    const w = this.rect.getW();
    const h = this.rect.getH();

    this.ctx.fillStyle = this.fill_color;

    const has_radius = Array.isArray( this.border_radius ) 
      ? this.border_radius.some( r => r > 0 )
      : this.border_radius > 0;

    if ( has_radius )
    {
      this.ctx.beginPath();
      this.ctx.roundRect( x, y, w, h, this.border_radius );
      this.ctx.fill();
    } 
    else 
    {
      this.ctx.fillRect( x, y, w, h );
    }

    this.finishRender();
  }

  public name(): string {
    return "UICanvasRect";
  }

  public update(now: number): void {
    this.updateBasic(now);
  }
}